import { ProfileConstant } from "../constants/profileConstant";

const initState = {
  socialLink: {
    instagram: "",
    facebook: "",
    twitter: "",
    youtube: "",
  },
};

export const SocialAddReducer = (state = initState, action) => {
  switch (action.type) {
    case ProfileConstant.CREATE_SOCIAL_SUCCESS:
      return {
        ...state,
        socialLink: {
          ...state.socialLink,
          instagram: action.payload.instagram,
          facebook: action.payload.facebook,
          twitter: action.payload.twitter,
          youtube: action.payload.youtube,
        },
      };
    default:
      return state;
  }
};
